<div class="flex flex-col max-w-[642px] m-auto pr-4 pl-4">
  <router-outlet></router-outlet>
</div>
